function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.277 14.933c-.519-1.579-.82-2.621-1.434-3.173-.201-.006-.43.089-.714.222-.594.28-1.225.635-1.858.99-1.624.911-3.268 1.756-4.464 1.756-1.339 0-3.206-1.222-5.261-2.713a1.913 1.913 0 00-1.54.384c-.767.595-1.276 1.62-1.7 2.613-.565 1.327-.271 3.269-.078 4.2C2.802 19.684 7.417 21 9.953 21c2.503 0 7.095-1.366 8.527-1.812.199-.616.503-2.108-.203-4.255zM9.863 1c-.944 0-1.787.478-2.402 1.216-.675.81-1.081 1.931-1.081 3.164s.406 2.354 1.081 3.164C8.076 9.28 8.92 9.76 9.863 9.76c.944 0 1.787-.479 2.402-1.216.675-.81 1.081-1.931 1.081-3.164s-.406-2.354-1.081-3.164C11.65 1.478 10.807 1 9.863 1z",
  stroke: "#FFF",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
});

function SvgMenuEmployeeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEmployeeActive);
export default __webpack_public_path__ + "static/media/menu-employee-active.d0cf762c.svg";
export { ForwardRef as ReactComponent };